import { render, staticRenderFns } from "./Wsxkz.vue?vue&type=template&id=4fd6676c&scoped=true&"
import script from "./Wsxkz.vue?vue&type=script&lang=js&"
export * from "./Wsxkz.vue?vue&type=script&lang=js&"
import style0 from "./Wsxkz.vue?vue&type=style&index=0&id=4fd6676c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd6676c",
  null
  
)

export default component.exports